import React from "react";
import { useCart } from "./CartContext";
import { FaTrashAlt } from "react-icons/fa";
import "../../styles.css";

const RemoveButton = ({ item }) => {
  const { removeFromCart } = useCart();

  const handleRemove = () => {
    removeFromCart(item.id, item.fabric, item.rangeModel, item.optionalExtras);
  };

  return (
    <button className="removeitem-button" onClick={handleRemove}>
      <FaTrashAlt />
    </button>
  );
};

export default RemoveButton;
